import React from 'react';

import { IconButton } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { withRouter } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { StyledTypography } from 'styles/common';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

// remove last suffix appended with _
const removePrefix = (text) => {
  const prefixEndIndex = text.indexOf('_');
  return text.slice(prefixEndIndex, text.length);
};

const ProcessStepper = ({
  history,
  currentStep,
  navigateToStep,
  formId,
  instanceName,
  maxStepConvered,
  currentStage,
  allowedStepsForPublished,
  allowedStepsForNonPublished,
  clickHandler,
  steps,
  title,
  removeDisplaySuffix = false,
}) => {
  const handleClick = () => clickHandler(history);

  const isCompleted = (step) => steps.indexOf(step) < steps.indexOf(maxStepConvered || currentStep);
  return (
    <Container>
      <Header>
        <IconButton>
          <ArrowBackIcon onClick={handleClick} />
        </IconButton>
        <Heading display="inline" color="#555">
          {instanceName || title}
        </Heading>
      </Header>
      <BodyContent>
        {steps.map((step, idx) => (
          <Step
            active={currentStep === step}
            pointer={
              formId && (step === steps[steps.length - 1] ? isCompleted(steps[steps.length - 2]) : isCompleted(step))
            }
            onClick={() =>
              formId &&
              (step === steps[steps.length - 1] && isCompleted(steps[steps.length - 2])
                ? navigateToStep(step)
                : isCompleted(step) && navigateToStep(step))
            }
            disabled={
              (currentStage !== 'DRAFT' && allowedStepsForNonPublished.indexOf(step) === -1) ||
              (currentStage === 'PUBLISHED' && allowedStepsForPublished.indexOf(step) === -1)
            }
          >
            {isCompleted(step) ? <CheckCircleIcon style={{ color: '#038eef' }} /> : <RadioButtonUncheckedIcon />}
            <StyledTypography variant="body" color="#444">
              {removeDisplaySuffix
                ? removePrefix(step).underscoreLess().toProperCase()
                : step.underscoreLess().toProperCase()}
            </StyledTypography>
            {idx !== 0 && <ConnectorLine top blue={currentStep === step || isCompleted(step)} />}
            {idx !== steps.length - 1 && <ConnectorLine bottom blue={isCompleted(step)} />}
          </Step>
        ))}
      </BodyContent>
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  width: ${() => {
    if (checkNewNavEnabled()) {
      return '288px';
    }
    return '19%';
  }};
  border-right: 1px solid #eee;
  background: white;
  left: ${() => {
    if (checkNewNavEnabled()) {
      return '80px';
    }
    return '0';
  }};
  top: ${(props) => {
    if (checkNewNavEnabled()) {
      return '0';
    }
    if (props.isExploringDemo) {
      return '14vh';
    }
    return '6vh';
  }};
  bottom: 0;
`;

const Header = styled.div`
  border-bottom: 1px solid #eee;
`;

const Heading = styled(StyledTypography)`
  font-size: 1.1rem;
  display: inline-block;
  vertical-align: sub;
  border-left: 1px solid #eee;
  line-height: 3rem;
  padding-left: 0.75rem;
`;

const BodyContent = styled.div`
  margin: 1.5rem 0;
`;

const ConnectorLine = styled.div`
  position: absolute;
  border-left: 2px solid #eee;
  left: 25px;
  top: 0;
  bottom: 25px;
  z-index: 1;
  ${(props) =>
    props.blue &&
    css`
      border-color: #038eef;
    `};
  ${(props) =>
    props.bottom &&
    css`
      top: 25px;
      bottom: 0;
    `};
`;

const Step = styled.div`
  padding: 0.75rem 0;
  position: relative;
  .MuiSvgIcon-root {
    font-size: 1.2rem;
    vertical-align: bottom;
    margin: 0 1rem;
    color: #ddd;
    z-index: 9;
    position: relative;
    background: white;
    border-radius: 50%;
  }
  ${(props) =>
    props.active &&
    css`
      background: #038eef12;
      .MuiTypography-root {
        color: #038eef;
        font-weight: bold;
      }
    `};
  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      cursor: initial;
      opacity: 0.4;
    `};
  ${(props) =>
    props.pointer &&
    css`
      cursor: pointer;
      &:hover {
        background: #fafafa;
      }
    `};
`;

export default withRouter(ProcessStepper);
